import React from "react";

export default function DoneIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" id="done">
      <path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path>
    </svg>
  );
}
